import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Route, Routes, Link} from 'react-router-dom';
import axios from 'axios';
import {QueryClientProvider, QueryClient} from '@tanstack/react-query';
import './App.css';
import {hi, ho, he} from './store';
import User from './user';

import Protex from './uzera';
import Wonha from './wonha';
import Uder from './uder';
import Aca from './aca';
import Gbar from './contest';
import Show from './clik';
import Yama from './yama';
import {Join, Notex} from './join';
import Find from './find';
import Baguo from './baguo';
import {Sins,Motex} from './sins';
import Paging from './paging';
import Targets from './targets';
import Chara from './chasu';
import Acti from './acti';
import Moon from './Moon';
import Learns from './Learns';
import Mbar from './mbar';
import Mwonha from './mwonha';
import Dolpa from './dolpa';
import Infopr from './infopr';
import Affi from './affi';
import Clause from './clause';
import Ganip from './ganip';
import Bama from './bama';
import Doogo from './doogo';
import Doogom from './doogom';
import Zins from './zins';
import Tazan from './tazan';
import Toon from './toon';
import Eonja from './eonja';
import Eoon from './eoon';
import Hizan from './hizan';
import Hoon from './hoon';
import Brotex from './muzare';

import {isMobile, BrowserView, MobileView} from 'react-device-detect';
import Mpaging from './mpaging';
axios.defaults.withCredentials = true;

function App() {
    const [page, setpage] = useState(false);
    const furi = useSelector(state=>state.midori);
    const fura = useSelector(state=>state.mahena);
    const dispatch = useDispatch();
    

    const gatclient = new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 10*(60*1000), // 10 mins
            cacheTime: 15*(60*1000), // 15 mins
          },
        },
      });

    window.addEventListener("DOMContentLoaded", (e)=>{
        const scrollpos = sessionStorage.getItem('scrollpos');
        if (scrollpos) {
            window.scrollTo(0, scrollpos);
            sessionStorage.removeItem('scrollpos');
        };
    });

    window.addEventListener("beforeunload", (e)=>{
        sessionStorage.setItem('scrollpos', window.scrollY);
    });

    useEffect(()=>{
        const kake = async ()=>{ 
            const kang = await axios.get('/api/gone',{withCredentials: true}).then(dadi=>{

                
                if(dadi.data?.id){
                    if(dadi.data?.trophy){
                    const {trophy} = dadi.data;
                    let donm;
                    let anamich;
                    if(trophy == null){
                      donm = [];
                    }else{
                     anamich = trophy.split("?");
                     donm = anamich.map((a)=>JSON.parse(a));
                    };   
              
                    const mabak = {...dadi.data, trophy : donm};
                    dispatch(he(mabak));
                }else{
                    const {post} = dadi.data;
                    let ddonm;
                    let aanamich;
                    if(post == null){
                      ddonm = [];
                    }else{
                     ddonm = JSON.parse(post);
                    };   
              
                    const mmabak = {...dadi.data, post : ddonm};
                    dispatch(he(mmabak));
                };
                };
            }).catch(e=>{ });};
        kake();
    },
    []); 

    return (
        <div className={isMobile ? "Appm" : "App"}>
        <QueryClientProvider client={gatclient}>
    <MobileView>
        <Mbar/>
        <Routes>
             <Route index element={<Uder/>}/>    
             <Route path="under" element={<User/>}>
                    <Route path="pro" element={<Brotex user={fura}></Brotex>}/>
                    <Route path="prw" element={<Acti colls="공모전" jp="0"/>}/>
                    <Route path="pra" element={<Acti colls="대외활동" jp="1"/>}/>
                    <Route path="pry" element={<Acti colls="교육" jp="2"/>}/>
                    <Route path="search" element={<Chara/>}/>
                </Route>
                <Route path='targets' element={<Targets/>}/>

                <Route path='jika' element={<Aca/>}>
                    <Route index element={<Learns/>}/>
                    <Route path=':way' element={<Moon/>}/>
                </Route>
                
                <Route path='mika' element={<Aca/>}>
                    <Route index element={<Tazan/>}/>
                    <Route path=':way' element={<Toon/>}/>
                </Route>

                <Route path='hika' element={<Aca/>}>
                    <Route index element={<Hizan/>}/>
                    <Route path=':way' element={<Hoon/>}/>
                </Route>

                <Route path='eika' element={<Aca/>}>
                    <Route index element={<Eonja/>}/>
                    <Route path=':way' element={<Eoon/>}/>
                </Route>

                <Route path="ajo" element={<Aca/>}>
                    <Route index element={<Mpaging/>}/>
                    <Route path=":wow" element={<Show/>}/>
                </Route>
                <Route path='sin' element={<Motex user={fura}><Zins/></Motex>}/>
                <Route path='son' element={<Mwonha/>}/>
                <Route path='dolpa' element={<Dolpa/>}/>
                <Route path='infopr' element={<Infopr/>}/>
                <Route path='affi' element={<Affi/>}/>
                <Route path='clause' element={<Clause/>}/>
                <Route path='gayip' element={<Ganip/>}>
                    <Route index element={<Doogom/>}/>
                    <Route path='yama' element={<Yama/>}/>
                    <Route path='bama' element={<Bama/>}/>
                </Route>
                <Route path='join' element={<Notex user={fura}><Join/></Notex>}/>
                <Route path='find' element={<Find/>}/>
                <Route path='bagguo' element={<Baguo/>}/>
        </Routes>
        <Mull/>
    </MobileView>
    <BrowserView>
            <Gbar/>
            <Routes>
                <Route index element={<Uder/>}/>
                <Route path="under" element={<User/>}>
                    <Route path="pro" element={<Protex user={fura}></Protex>}/>
                    <Route path="prw" element={<Acti colls="공모전" jp="0"/>}/>
                    <Route path="pra" element={<Acti colls="대외활동" jp="1"/>}/>
                    <Route path="pry" element={<Acti colls="교육" jp="2"/>}/>
                    <Route path="search" element={<Chara/>}/>
                </Route>
                <Route path='targets' element={<Targets/>}/>

                <Route path='jika' element={<Aca/>}>
                    <Route index element={<Learns/>}/>
                    <Route path=':way' element={<Moon/>}/>
                </Route>

                <Route path='mika' element={<Aca/>}>
                    <Route index element={<Tazan/>}/>
                    <Route path=':way' element={<Toon/>}/>
                </Route>

                <Route path='hika' element={<Aca/>}>
                    <Route index element={<Hizan/>}/>
                    <Route path=':way' element={<Hoon/>}/>
                </Route>

                <Route path='eika' element={<Aca/>}>
                    <Route index element={<Eonja/>}/>
                    <Route path=':way' element={<Eoon/>}/>
                </Route>
                
                <Route path="ajo" element={<Aca/>}>
                    <Route index element={<Paging/>}/>
                    <Route path=":wow" element={<Show/>}/>
                </Route>
                <Route path='sin' element={<Motex user={fura}><Sins/></Motex>}/>
                <Route path='son' element={<Wonha/>}/>
                <Route path='dolpa' element={<Dolpa/>}/>
                <Route path='infopr' element={<Infopr/>}/>
                <Route path='affi' element={<Affi/>}/>
                <Route path='clause' element={<Clause/>}/>
                <Route path='gayip' element={<Ganip/>}>
                    <Route index element={<Doogo/>}/>
                    <Route path='yama' element={<Yama/>}/>
                    <Route path='bama' element={<Bama/>}/>
                </Route>
                <Route path='join' element={<Notex user={fura}><Join/></Notex>}/>
                <Route path='find' element={<Find/>}/>
                <Route path='bagguo' element={<Baguo/>}/>
            </Routes>
      
            <Bull/>
            
            </BrowserView>
            </QueryClientProvider>
        </div>
    );
}

const Bull = () => {

    return (
        <div className='footing'>
            <p className='footp'>
                <span className='foota'>돌파공모</span>
                <span className='blockf'></span>
                <span className='foota'>문의 guide@dolpagongmo.com</span>
                <span className='blockf'></span>
                <span className='foota'>대표전화 010-8634-0876</span>
            </p>
            <p className='footc'>
                <span className='foota'>사업자등록번호 136-123-14124</span>
                <span className='blockf'></span>
                <span className='foota'>대표 정승재</span> 
            </p>
            <p className='footc'>
                <span className='foota'>개인정보보호책임자 정승재</span>
                <span className='blockf'></span>
                <span className='foota'>주소 서울시 강남구 선정릉 비즈니스센터 3층</span>
            </p>
            <p className='footc'>
                <span className='foota'>ⓒ 돌파공모</span>
            </p>
        <div className='footing1'>
            <ul className='footing2'>
                <li className='footing3'><Link to='/dolpa' className='footing4'>회사소개</Link></li>
                <li className='footing3'><Link to='/clause' className='footing4'>이용약관</Link></li>
                <li className='footing3'><Link to='/infopr' className='footing4'>개인정보처리방침</Link></li>
                <li className='footing3'><Link to='/affi' className='footing4'>제휴&제안</Link></li>
                <li className='footing3'><Link to='/son' className='footing4'>광고안내</Link></li>
            </ul>
        </div>
        </div>
    );
};

const Mull = () => {

    return (
        <div className='footing'>
            <p className='mfootp'>
                <span className='mfoota'>돌파공모</span>
                <span className='mblockf'></span>
                <span className='mfoota'>문의 guide@dolpagongmo.com</span>
                <span className='mblockf'></span>
                <span className='mfoota'>대표전화 010-8634-0876</span>
            </p>
            <p className='mfootc'>
                <span className='mfoota'>사업자등록번호 136-123-14124</span>
                <span className='mblockf'></span>
                <span className='mfoota'>대표 정승재</span> 
            </p>
            <p className='mfootd'>
                <span className='mfoota'>개인정보보호책임자 정승재</span>
                <span className='mblockf'></span>
                <span className='mfoota'>주소 서울시 강남구 선정릉 비즈니스센터 3층</span>
            </p>
            <p className='mfootc'>
                <span className='mfoota'>ⓒ 돌파공모</span>
            </p>
        <div className='mfooting1'>
            <ul className='footing2'>
                <li className='mfooting3'><Link to='/dolpa' className='footing4'>회사소개</Link></li>
                <li className='mfooting3'><Link to='/clause' className='footing4'>이용약관</Link></li>
                <li className='mfooting3'><Link to='/infopr' className='footing4'>개인정보처리방침</Link></li>
                <li className='mfooting3'><Link to='/affi' className='footing4'>제휴&제안</Link></li>
                <li className='mfooting3'><Link to='/son' className='footing4'>광고안내</Link></li>
            </ul>
        </div>
        </div>
    );
};

export default App;
